import { Component, Element, Host, Prop, h } from '@stencil/core';

import { trackVehDetail } from '../../../tracking/tracking.detail';

export interface EquipmentOption {
  displayName: string;
}

@Component({
  tag: 'vehicle-features-equipment-modal',
  styleUrl: 'vehicle-features-equipment-modal.css',
})
export class VehicleFeaturesEquipmentModal {
  @Element() el: HTMLElement;

  @Prop() options: EquipmentOption[] = [];

  openFeaturesModal(evt: MouseEvent) {
    evt.preventDefault();
    const modal = this.el.querySelector('ico-modal#vehicle-features-equipment-modal') as HTMLIcoModalElement;
    trackVehDetail('seeAllFeaturesEquipment', 'click');
    modal.open();
  }

  hideFeaturesModal() {
    const modal = this.el.querySelector('ico-modal#vehicle-features-equipment-modal') as HTMLIcoModalElement;
    modal.close();
  }

  render() {
    return (
      <Host>
        <div class="text-center mt-4">
          <a href="#" class="no-underline font-bold text-sm font-ico-body" onClick={this.openFeaturesModal.bind(this)}>
            See all features & equipment
          </a>
        </div>
        <ico-modal borderedFooter id="vehicle-features-equipment-modal">
          <div slot="header" class="ico-components-heading">
            Features & Equipment
          </div>
          <div class="pb-4">
            <div class="md:columns-2">
              {this.options.map((opt) => {
                return <div class="md:pr-40 text-sm mb-1">{opt.displayName}</div>;
              })}
            </div>
          </div>
          <div slot="footer" class="flex flex-row justify-end">
            <ico-button label="Done" buttonSize="large" whenClicked={this.hideFeaturesModal.bind(this)} />
          </div>
        </ico-modal>
      </Host>
    );
  }
}
